import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App';
import { ProvedorApresentacao } from './apresentacao/ModoApresentacao';
import { ProvedorAuth } from './auth/AuthContext';
import { iniciarClarity } from './utils/clarity';
import './styles/global.css';

const clienteQuery = new QueryClient({
  defaultOptions: {
    queries: {
      // O banco fica remoto (≈180 ms por consulta), então cada requisição
      // custa perto de um segundo. Com 5 min de validade, navegar entre telas
      // e voltar não refaz nada — e o que muda por ação do usuário já é
      // invalidado explicitamente pelas mutações.
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      // 401 é tratado pelo interceptor (renova o token e refaz a chamada).
      // Repetir aqui só multiplicaria requisições já condenadas.
      retry: (tentativas, erro) => {
        const status = (erro as { response?: { status?: number } })?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return tentativas < 2;
      },
    },
  },
});

iniciarClarity();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteQuery}>
      <BrowserRouter>
        <ProvedorAuth>
          <ProvedorApresentacao>
            <App />
          </ProvedorApresentacao>
        </ProvedorAuth>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
